import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';

import './header.css';
import { auth } from '../../firebase';
import { HeaderProps } from './header.props';
import { ArrowLeft, Crown, Sword } from 'lucide-react';
import { LogOutOutline, PersonFill } from '../../assets';
import { IconSVG } from '../icon';
import { ROUTES } from '../../routes';

const Header = ({
  league,
  className,
  title,
  titleComponent,
  goBack,
}: HeaderProps) => {
  const TitleComponent = () => {
    return (
      <div className="isg-header-1-title-container">
        {titleComponent?.component}
      </div>
    );
  };

  return (
    <>
      {league === undefined ? (
        <header className={`isg-header isg-header-1-container ${className}`}>
          {goBack && (
            <>
              <Link
                to={goBack.path}
                target="_top"
                className="isg-header-2-to-home"
              >
                <ArrowLeft
                  className="isg-header-2-back-icon"
                  stroke="#9ca3af"
                />
                {goBack.text ? goBack.text : 'Volver al inicio'}
              </Link>
            </>
          )}

          {title && !titleComponent ? (
            <>
              <div className="isg-header-1-title-container">
                <h1 className="isg-header-1-title">{title}</h1>
              </div>
            </>
          ) : !title && !titleComponent ? (
            <>
              <div className="isg-header-1-box">
                <div className="isg-header-1">
                  <Crown className="isg-header-icon" stroke="#CAFB10" />
                  <h1 className="isg-header-1-title">Imperial Stones Game</h1>
                  <Sword className="isg-header-icon" stroke="#F31000" />
                </div>
                <p className="isg-header-1-slogan">
                  Colecciona. Compite. Conquista.
                </p>
              </div>
            </>
          ) : (
            <TitleComponent />
          )}

          <User />
        </header>
      ) : (
        <header className={`isg-header isg-header-2-container ${className}`}>
          <div className="isg-header-2">
            <div className="isg-header-2-box">
              {/* <Link
                to={ROUTES.HOME}
                target="_top"
                className="isg-header-2-to-home"
              >
                <ArrowLeft
                  className="isg-header-2-back-icon"
                  stroke="#9ca3af"
                />
                Volver al inicio
              </Link> */}

              <div className="isg-header-2-league-box">
                <div className="isg-header-2-league-icon-box">
                  <span className="isg-header-2-league-icon">
                    {league.icon}
                  </span>
                </div>
                <h1 className="isg-header-2-league-name">{league.name}</h1>
              </div>
            </div>

            <User />
          </div>
        </header>
      )}
    </>
  );
};

export default Header;

const User = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="isg-header-user" ref={menuRef}>
      <button className="isg-header-user-button" onClick={toggleMenu}>
        <IconSVG Icon={PersonFill} fill="#ffffff" />
      </button>

      {open && (
        <div className="isg-header-menu">
          {/* <Link
            to={ROUTES.PROFILE}
            target="_top"
            className="isg-header-menu-button"
          >
            <IconSVG
              Icon={PersonFill}
              stroke="#000000"
              fill="#ffffff00"
              size={24}
              className="isg-header-menu-button-icon"
            />
            <p>Mi perfil</p>
          </Link>
          <div className="isg-header-menu-divider" /> */}
          <button className="isg-header-menu-button" onClick={handleLogout}>
            <IconSVG
              Icon={LogOutOutline}
              stroke="#000000"
              fill="#ffffff00"
              size={24}
              className="isg-header-menu-button-icon"
            />
            <p>Cerrar sesión</p>
          </button>
        </div>
      )}
    </div>
  );
};
